export default function () {
  const asOf = null;
  const asOfLive = "";
  const asOfHourly = "";
  const asOfWeekly = "";
  const marketStatus = false;
  const isLtpVsCloseLive = false;
  return {
    asOf: asOf,
    asOfLive: asOfLive,
    asOfHourly: asOfHourly,
    asOfWeekly: asOfWeekly,
    marketStatus: marketStatus,
    isLtpVsCloseLive: isLtpVsCloseLive,
  };
}
